// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Settings_settingsContainer__f6vbr {
  min-height: 100vh;
  background: linear-gradient(135deg, #0467a0 0%, #035a8a 50%, #ff0000 100%);
  padding: 20px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.Settings_header__Mx7Zp {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 20px;
  padding: 30px;
  margin-bottom: 25px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 2px solid rgba(255, 255, 255, 0.2);
}
.Settings_header__Mx7Zp .Settings_headerContent__N6Zab h1 {
  font-size: 2.5rem;
  font-weight: 700;
  background: linear-gradient(135deg, #0467a0 0%, #ff0000 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0 0 10px 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.Settings_header__Mx7Zp .Settings_headerContent__N6Zab p {
  font-size: 1.1rem;
  color: #6c757d;
  margin: 0;
  font-weight: 500;
}
.Settings_header__Mx7Zp .Settings_headerActions__JMlFK {
  display: flex;
  gap: 15px;
  align-items: center;
}
.Settings_header__Mx7Zp .Settings_headerActions__JMlFK .Settings_downloadButton__RzieJ {
  background: linear-gradient(135deg, #0467a0 0%, #035a8a 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(4, 103, 160, 0.3);
}
.Settings_header__Mx7Zp .Settings_headerActions__JMlFK .Settings_downloadButton__RzieJ:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(4, 103, 160, 0.4);
}
.Settings_header__Mx7Zp .Settings_headerActions__JMlFK .Settings_downloadButton__RzieJ:active {
  transform: translateY(0);
}
.Settings_header__Mx7Zp .Settings_headerActions__JMlFK .Settings_refreshButton__Bazue {
  background: linear-gradient(135deg, #0467a0 0%, #ff0000 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(4, 103, 160, 0.3);
}
.Settings_header__Mx7Zp .Settings_headerActions__JMlFK .Settings_refreshButton__Bazue:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(4, 103, 160, 0.4);
}
.Settings_header__Mx7Zp .Settings_headerActions__JMlFK .Settings_refreshButton__Bazue:active {
  transform: translateY(0);
}
@media (max-width: 768px) {
  .Settings_header__Mx7Zp {
    flex-direction: column;
    gap: 15px;
  }
  .Settings_header__Mx7Zp .Settings_headerContent__N6Zab {
    text-align: center;
  }
  .Settings_header__Mx7Zp .Settings_headerContent__N6Zab h1 {
    font-size: 2rem !important;
  }
  .Settings_header__Mx7Zp .Settings_headerActions__JMlFK {
    flex-direction: column;
    gap: 10px;
    width: 100%;
  }
  .Settings_header__Mx7Zp .Settings_headerActions__JMlFK button {
    width: 100%;
    justify-content: center;
  }
}

.Settings_searchFilterBar__SBmUI {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 15px;
  padding: 25px;
  margin-bottom: 25px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  gap: 20px;
  border: 2px solid rgba(255, 255, 255, 0.2);
}
.Settings_searchFilterBar__SBmUI .Settings_filterSummary__Lf4iE {
  background: linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%);
  border-radius: 10px;
  padding: 15px;
  border-left: 4px solid #667eea;
}
.Settings_searchFilterBar__SBmUI .Settings_filterSummary__Lf4iE .Settings_filterSummaryLabel__-qwXJ {
  font-weight: 600;
  color: #2c3e50;
  margin-right: 10px;
  font-size: 0.95rem;
}
.Settings_searchFilterBar__SBmUI .Settings_filterSummary__Lf4iE .Settings_activeFilters__YasHQ {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 8px;
}
.Settings_searchFilterBar__SBmUI .Settings_filterSummary__Lf4iE .Settings_activeFilters__YasHQ .Settings_filterTag__h4y\\+6 {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.85rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}
.Settings_searchFilterBar__SBmUI .Settings_filterSummary__Lf4iE .Settings_activeFilters__YasHQ .Settings_filterTag__h4y\\+6 button {
  background: none;
  border: none;
  color: white;
  font-size: 1rem;
  cursor: pointer;
  padding: 0;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}
.Settings_searchFilterBar__SBmUI .Settings_filterSummary__Lf4iE .Settings_activeFilters__YasHQ .Settings_filterTag__h4y\\+6 button:hover {
  background-color: rgba(255, 255, 255, 0.2);
}
.Settings_searchFilterBar__SBmUI .Settings_searchSection__u1-MJ {
  display: flex;
  justify-content: center;
  width: 100%;
}
.Settings_searchFilterBar__SBmUI .Settings_searchSection__u1-MJ .Settings_searchBox__ekRwS {
  position: relative;
  max-width: 500px;
  width: 100%;
}
.Settings_searchFilterBar__SBmUI .Settings_searchSection__u1-MJ .Settings_searchBox__ekRwS .Settings_searchIcon__2NzQU {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #6c757d;
  font-size: 1.1rem;
}
.Settings_searchFilterBar__SBmUI .Settings_searchSection__u1-MJ .Settings_searchBox__ekRwS .Settings_searchInput__UeYSY {
  width: 100%;
  padding: 15px 15px 15px 50px;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  font-size: 1rem;
  background: white;
  transition: all 0.3s ease;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);
}
.Settings_searchFilterBar__SBmUI .Settings_searchSection__u1-MJ .Settings_searchBox__ekRwS .Settings_searchInput__UeYSY:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1), inset 0 2px 4px rgba(0, 0, 0, 0.05);
  transform: translateY(-1px);
}
.Settings_searchFilterBar__SBmUI .Settings_searchSection__u1-MJ .Settings_searchBox__ekRwS .Settings_searchInput__UeYSY::placeholder {
  color: #adb5bd;
  font-style: italic;
}
.Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg {
  display: flex;
  gap: 15px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}
.Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_filterSelect__NVxK8,
.Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_sortSelect__cEJFv {
  padding: 12px 16px;
  border: 2px solid #e9ecef;
  border-radius: 10px;
  font-size: 0.95rem;
  background: white;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 150px;
  font-weight: 500;
}
.Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_filterSelect__NVxK8:focus,
.Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_sortSelect__cEJFv:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  transform: translateY(-1px);
}
.Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_filterSelect__NVxK8:hover,
.Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_sortSelect__cEJFv:hover {
  border-color: #667eea;
  transform: translateY(-1px);
}
.Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_sortButton__Trzou {
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  border: none;
  padding: 12px 16px;
  border-radius: 10px;
  font-size: 0.95rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
}
.Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_sortButton__Trzou:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
}
.Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_dateFilterToggle__0YHtb {
  display: flex;
  gap: 5px;
  background: #f8f9fa;
  border-radius: 8px;
  padding: 4px;
  border: 1px solid #e9ecef;
}
.Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_dateFilterToggle__0YHtb .Settings_dateTypeButton__sDl67 {
  background: none;
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #6c757d;
  font-weight: 500;
}
.Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_dateFilterToggle__0YHtb .Settings_dateTypeButton__sDl67.Settings_active__Oddne {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
}
.Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_dateFilterToggle__0YHtb .Settings_dateTypeButton__sDl67:hover:not(.Settings_active__Oddne) {
  background: rgba(102, 126, 234, 0.1);
  color: #667eea;
}
.Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_dateRangeSection__rDaP\\+ {
  display: flex;
  gap: 10px;
  align-items: center;
}
.Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_dateRangeSection__rDaP\\+ .Settings_dateInput__6zaor {
  position: relative;
  display: flex;
  align-items: center;
}
.Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_dateRangeSection__rDaP\\+ .Settings_dateInput__6zaor .Settings_dateIcon__lyALk {
  position: absolute;
  left: 12px;
  color: #6c757d;
  font-size: 0.9rem;
  z-index: 1;
}
.Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_dateRangeSection__rDaP\\+ .Settings_dateInput__6zaor .Settings_dateInputField__B9Bje {
  padding: 10px 10px 10px 35px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 0.9rem;
  background: white;
  transition: all 0.3s ease;
  min-width: 140px;
}
.Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_dateRangeSection__rDaP\\+ .Settings_dateInput__6zaor .Settings_dateInputField__B9Bje:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}
.Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_dateRangeSection__rDaP\\+ .Settings_dateInput__6zaor .Settings_dateInputField__B9Bje::placeholder {
  color: #adb5bd;
  font-size: 0.8rem;
}
.Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_clearFiltersButton__m6652 {
  background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
  color: white;
  border: none;
  padding: 12px 16px;
  border-radius: 10px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  position: relative;
}
.Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_clearFiltersButton__m6652:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);
}
.Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_clearFiltersButton__m6652::before {
  content: "";
  position: absolute;
  top: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  background: #ffc107;
  border-radius: 50%;
  opacity: 0;
  transition: opacity 0.3s ease;
}
.Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_clearFiltersButton__m6652.Settings_hasFilters__4tJuv::before {
  opacity: 1;
}

.Settings_errorMessage__bFpI5 {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
  color: white;
  padding: 15px 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3);
  animation: Settings_slideInDown__L4FPL 0.3s ease;
}
.Settings_errorMessage__bFpI5 button {
  background: none;
  border: none;
  color: white;
  font-size: 1.2rem;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}
.Settings_errorMessage__bFpI5 button:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.Settings_loadingContainer__iG9YI {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 20px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
}
.Settings_loadingContainer__iG9YI .Settings_loadingSpinner__UmfJH {
  width: 50px;
  height: 50px;
  border: 4px solid #e9ecef;
  border-top: 4px solid #667eea;
  border-radius: 50%;
  animation: Settings_spin__2fjp\\+ 1s linear infinite;
  margin-bottom: 20px;
}
.Settings_loadingContainer__iG9YI p {
  font-size: 1.1rem;
  color: #6c757d;
  margin: 0;
  font-weight: 500;
}

.Settings_itemsContainer__96kQX .Settings_emptyState__NEseT {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 20px;
  padding: 60px 20px;
  text-align: center;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
}
.Settings_itemsContainer__96kQX .Settings_emptyState__NEseT .Settings_emptyIcon__S\\+yLM {
  font-size: 4rem;
  margin-bottom: 20px;
  display: block;
}
.Settings_itemsContainer__96kQX .Settings_emptyState__NEseT h3 {
  font-size: 1.5rem;
  color: #495057;
  margin: 0 0 10px 0;
  font-weight: 600;
}
.Settings_itemsContainer__96kQX .Settings_emptyState__NEseT p {
  color: #6c757d;
  margin: 0;
  font-size: 1rem;
}
.Settings_itemsContainer__96kQX .Settings_itemsGrid__mS7F\\+ {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 25px;
  margin-bottom: 30px;
}

.Settings_itemCard__Powmv {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 18px;
  padding: 25px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  border: 2px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.Settings_itemCard__Powmv::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}
.Settings_itemCard__Powmv:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);
}
.Settings_itemCard__Powmv .Settings_itemHeader__SCwd5 {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
}
.Settings_itemCard__Powmv .Settings_itemHeader__SCwd5 .Settings_itemTitle__nGE68 {
  flex: 1 1;
}
.Settings_itemCard__Powmv .Settings_itemHeader__SCwd5 .Settings_itemTitle__nGE68 h3 {
  font-size: 1.3rem;
  font-weight: 700;
  color: #2c3e50;
  margin: 0 0 8px 0;
  line-height: 1.3;
}
.Settings_itemCard__Powmv .Settings_itemHeader__SCwd5 .Settings_itemTitle__nGE68 .Settings_itemId__ZQrc7 {
  font-size: 0.9rem;
  color: #6c757d;
  font-weight: 500;
  background: #e9ecef;
  padding: 4px 8px;
  border-radius: 6px;
  display: inline-block;
}
.Settings_itemCard__Powmv .Settings_itemHeader__SCwd5 .Settings_itemActions__\\+cVS7 {
  display: flex;
  gap: 8px;
}
.Settings_itemCard__Powmv .Settings_itemHeader__SCwd5 .Settings_itemActions__\\+cVS7 .Settings_actionButton__H6fY2 {
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  font-weight: 600;
}
.Settings_itemCard__Powmv .Settings_itemHeader__SCwd5 .Settings_itemActions__\\+cVS7 .Settings_actionButton__H6fY2.Settings_viewButton__VwDo1 {
  background: linear-gradient(135deg, #17a2b8 0%, #20c997 100%);
  color: white;
}
.Settings_itemCard__Powmv .Settings_itemHeader__SCwd5 .Settings_itemActions__\\+cVS7 .Settings_actionButton__H6fY2.Settings_viewButton__VwDo1:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(23, 162, 184, 0.3);
}
.Settings_itemCard__Powmv .Settings_itemHeader__SCwd5 .Settings_itemActions__\\+cVS7 .Settings_actionButton__H6fY2.Settings_editButton__LL-RN {
  background: linear-gradient(135deg, #ffc107 0%, #fd7e14 100%);
  color: white;
}
.Settings_itemCard__Powmv .Settings_itemHeader__SCwd5 .Settings_itemActions__\\+cVS7 .Settings_actionButton__H6fY2.Settings_editButton__LL-RN:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(255, 193, 7, 0.3);
}
.Settings_itemCard__Powmv .Settings_itemHeader__SCwd5 .Settings_itemActions__\\+cVS7 .Settings_actionButton__H6fY2.Settings_deleteButton__srDaK {
  background: linear-gradient(135deg, #dc3545 0%, #e74c3c 100%);
  color: white;
}
.Settings_itemCard__Powmv .Settings_itemHeader__SCwd5 .Settings_itemActions__\\+cVS7 .Settings_actionButton__H6fY2.Settings_deleteButton__srDaK:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);
}
.Settings_itemCard__Powmv .Settings_itemDetails__AIdBH {
  margin-bottom: 20px;
}
.Settings_itemCard__Powmv .Settings_itemDetails__AIdBH .Settings_detailRow__nLiiN {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f1f3f4;
}
.Settings_itemCard__Powmv .Settings_itemDetails__AIdBH .Settings_detailRow__nLiiN:last-child {
  border-bottom: none;
}
.Settings_itemCard__Powmv .Settings_itemDetails__AIdBH .Settings_detailRow__nLiiN .Settings_detailLabel__e0M-y {
  font-weight: 600;
  color: #495057;
  font-size: 0.95rem;
}
.Settings_itemCard__Powmv .Settings_itemDetails__AIdBH .Settings_detailRow__nLiiN .Settings_detailValue__7vVQm {
  color: #6c757d;
  font-weight: 500;
  font-size: 0.95rem;
  text-align: right;
  max-width: 60%;
  word-break: break-word;
}
.Settings_itemCard__Powmv .Settings_itemFooter__sgGZT {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 15px;
  border-top: 1px solid #f1f3f4;
  font-size: 0.85rem;
}
.Settings_itemCard__Powmv .Settings_itemFooter__sgGZT .Settings_createdDate__IhkG-,
.Settings_itemCard__Powmv .Settings_itemFooter__sgGZT .Settings_updatedDate__UEqid {
  color: #6c757d;
  font-weight: 500;
}

.Settings_pagination__sbN-9 {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-top: 30px;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 15px;
  padding: 20px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
}
.Settings_pagination__sbN-9 .Settings_paginationButton__JEvQG {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 10px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
.Settings_pagination__sbN-9 .Settings_paginationButton__JEvQG:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}
.Settings_pagination__sbN-9 .Settings_paginationButton__JEvQG:disabled {
  background: #e9ecef;
  color: #6c757d;
  cursor: not-allowed;
  transform: none;
}
.Settings_pagination__sbN-9 .Settings_pageNumbers__7Ldrb {
  display: flex;
  gap: 8px;
}
.Settings_pagination__sbN-9 .Settings_pageNumbers__7Ldrb .Settings_pageButton__ADCGa {
  width: 40px;
  height: 40px;
  border: 2px solid #e9ecef;
  background: white;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
.Settings_pagination__sbN-9 .Settings_pageNumbers__7Ldrb .Settings_pageButton__ADCGa:hover {
  border-color: #667eea;
  transform: translateY(-1px);
}
.Settings_pagination__sbN-9 .Settings_pageNumbers__7Ldrb .Settings_pageButton__ADCGa.Settings_activePage__GkJVT {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-color: #667eea;
}

.Settings_modalOverlay__9ASjN {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: Settings_fadeIn__7gJaS 0.3s ease;
}

.Settings_confirmationModal__FP-R\\+ {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 20px;
  padding: 0;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: Settings_slideInUp__OerG1 0.3s ease;
  overflow: hidden;
}
.Settings_confirmationModal__FP-R\\+ .Settings_modalHeader__NuRGy {
  background: linear-gradient(135deg, #dc3545 0%, #e74c3c 100%);
  color: white;
  padding: 25px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Settings_confirmationModal__FP-R\\+ .Settings_modalHeader__NuRGy h3 {
  margin: 0;
  font-size: 1.4rem;
  font-weight: 700;
}
.Settings_confirmationModal__FP-R\\+ .Settings_modalHeader__NuRGy .Settings_closeButton__dsii1 {
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}
.Settings_confirmationModal__FP-R\\+ .Settings_modalHeader__NuRGy .Settings_closeButton__dsii1:hover {
  background-color: rgba(255, 255, 255, 0.2);
}
.Settings_confirmationModal__FP-R\\+ .Settings_modalContent__hkX0k {
  padding: 30px;
  text-align: center;
}
.Settings_confirmationModal__FP-R\\+ .Settings_modalContent__hkX0k .Settings_warningIcon__9hxU7 {
  font-size: 3rem;
  margin-bottom: 20px;
  display: block;
}
.Settings_confirmationModal__FP-R\\+ .Settings_modalContent__hkX0k p {
  font-size: 1.1rem;
  color: #495057;
  margin: 0 0 20px 0;
  font-weight: 500;
}
.Settings_confirmationModal__FP-R\\+ .Settings_modalContent__hkX0k .Settings_itemPreview__-uWE5 {
  background: #f8f9fa;
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 20px;
  border-left: 4px solid #dc3545;
}
.Settings_confirmationModal__FP-R\\+ .Settings_modalContent__hkX0k .Settings_itemPreview__-uWE5 strong {
  display: block;
  color: #2c3e50;
  font-size: 1.1rem;
  margin-bottom: 5px;
}
.Settings_confirmationModal__FP-R\\+ .Settings_modalContent__hkX0k .Settings_itemPreview__-uWE5 span {
  color: #6c757d;
  font-size: 0.9rem;
}
.Settings_confirmationModal__FP-R\\+ .Settings_modalContent__hkX0k .Settings_warningText__QzYNK {
  color: #dc3545;
  font-size: 0.95rem;
  font-weight: 600;
  background: #fff5f5;
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #fed7d7;
}
.Settings_confirmationModal__FP-R\\+ .Settings_modalActions__ICG7s {
  padding: 0 30px 30px;
  display: flex;
  gap: 15px;
  justify-content: flex-end;
}
.Settings_confirmationModal__FP-R\\+ .Settings_modalActions__ICG7s .Settings_cancelButton__6EHQT {
  background: #6c757d;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
.Settings_confirmationModal__FP-R\\+ .Settings_modalActions__ICG7s .Settings_cancelButton__6EHQT:hover {
  background: #5a6268;
  transform: translateY(-1px);
}
.Settings_confirmationModal__FP-R\\+ .Settings_modalActions__ICG7s .Settings_deleteConfirmButton__\\+821q {
  background: linear-gradient(135deg, #dc3545 0%, #e74c3c 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}
.Settings_confirmationModal__FP-R\\+ .Settings_modalActions__ICG7s .Settings_deleteConfirmButton__\\+821q:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);
}

.Settings_editFormHeader__8Jpco {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border-radius: 20px;
  padding: 25px 30px;
  margin-bottom: 25px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.Settings_editFormHeader__8Jpco h2 {
  font-size: 2rem;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  margin: 0;
}
.Settings_editFormHeader__8Jpco .Settings_backButton__BURpw {
  background: linear-gradient(135deg, #6c757d 0%, #495057 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}
.Settings_editFormHeader__8Jpco .Settings_backButton__BURpw:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3);
}

@keyframes Settings_fadeIn__7gJaS {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes Settings_slideInUp__OerG1 {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes Settings_slideInDown__L4FPL {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes Settings_spin__2fjp\\+ {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media (max-width: 768px) {
  .Settings_settingsContainer__f6vbr {
    padding: 15px;
  }
  .Settings_header__Mx7Zp {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }
  .Settings_header__Mx7Zp .Settings_headerContent__N6Zab h1 {
    font-size: 2rem;
  }
  .Settings_searchFilterBar__SBmUI {
    flex-direction: column;
    gap: 15px;
  }
  .Settings_searchFilterBar__SBmUI .Settings_searchSection__u1-MJ .Settings_searchBox__ekRwS {
    max-width: 100%;
  }
  .Settings_searchFilterBar__SBmUI .Settings_filterSummary__Lf4iE .Settings_activeFilters__YasHQ {
    justify-content: center;
  }
  .Settings_searchFilterBar__SBmUI .Settings_filterSummary__Lf4iE .Settings_activeFilters__YasHQ .Settings_filterTag__h4y\\+6 {
    font-size: 0.8rem;
    padding: 4px 8px;
  }
  .Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg {
    flex-wrap: wrap;
    justify-content: center;
    flex-direction: column;
    gap: 10px;
  }
  .Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_filterSelect__NVxK8,
  .Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_sortSelect__cEJFv {
    min-width: 120px;
    width: 100%;
  }
  .Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_dateRangeSection__rDaP\\+ {
    flex-direction: column;
    width: 100%;
  }
  .Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_dateRangeSection__rDaP\\+ .Settings_dateInput__6zaor {
    width: 100%;
  }
  .Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_dateRangeSection__rDaP\\+ .Settings_dateInput__6zaor .Settings_dateInputField__B9Bje {
    width: 100%;
    min-width: auto;
  }
  .Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_dateFilterToggle__0YHtb {
    width: 100%;
    justify-content: center;
  }
  .Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_clearFiltersButton__m6652,
  .Settings_searchFilterBar__SBmUI .Settings_filterSection__R2uVg .Settings_sortButton__Trzou {
    width: 100%;
    justify-content: center;
  }
  .Settings_itemsGrid__mS7F\\+ {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  .Settings_itemCard__Powmv {
    padding: 20px;
  }
  .Settings_itemCard__Powmv .Settings_itemHeader__SCwd5 {
    flex-direction: column;
    gap: 15px;
    align-items: flex-start;
  }
  .Settings_itemCard__Powmv .Settings_itemHeader__SCwd5 .Settings_itemActions__\\+cVS7 {
    align-self: flex-end;
  }
  .Settings_itemCard__Powmv .Settings_itemFooter__sgGZT {
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }
  .Settings_pagination__sbN-9 {
    flex-direction: column;
    gap: 15px;
  }
  .Settings_pagination__sbN-9 .Settings_pageNumbers__7Ldrb {
    flex-wrap: wrap;
    justify-content: center;
  }
  .Settings_confirmationModal__FP-R\\+ {
    width: 95%;
    margin: 20px;
  }
  .Settings_confirmationModal__FP-R\\+ .Settings_modalActions__ICG7s {
    flex-direction: column;
    gap: 10px;
  }
  .Settings_confirmationModal__FP-R\\+ .Settings_modalActions__ICG7s button {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .Settings_header__Mx7Zp .Settings_headerContent__N6Zab h1 {
    font-size: 1.8rem;
  }
  .Settings_itemCard__Powmv {
    padding: 15px;
  }
  .Settings_itemCard__Powmv .Settings_itemHeader__SCwd5 .Settings_itemTitle__nGE68 h3 {
    font-size: 1.1rem;
  }
  .Settings_itemCard__Powmv .Settings_itemActions__\\+cVS7 .Settings_actionButton__H6fY2 {
    width: 35px;
    height: 35px;
    font-size: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/settings/Settings.module.scss"],"names":[],"mappings":"AACA;EACI,iBAAA;EACA,0EAAA;EACA,aAAA;EACA,4DAAA;AAAJ;;AAIA;EACI,6DAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,0CAAA;AADJ;AAIQ;EACI,iBAAA;EACA,gBAAA;EACA,6DAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,kBAAA;EACA,yCAAA;AAFZ;AAKQ;EACI,iBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;AAHZ;AAOI;EACI,aAAA;EACA,SAAA;EACA,mBAAA;AALR;AAOQ;EACI,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,6CAAA;AALZ;AAOY;EACI,2BAAA;EACA,6CAAA;AALhB;AAQY;EACI,wBAAA;AANhB;AAUQ;EACI,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,6CAAA;AARZ;AAUY;EACI,2BAAA;EACA,6CAAA;AARhB;AAWY;EACI,wBAAA;AAThB;AAeI;EAxFJ;IAyFQ,sBAAA;IACA,SAAA;EAZN;EAcM;IACI,kBAAA;EAZV;EAcU;IACI,0BAAA;EAZd;EAgBM;IACI,sBAAA;IACA,SAAA;IACA,WAAA;EAdV;EAgBU;IACI,WAAA;IACA,uBAAA;EAdd;AACF;;AAoBA;EACI,6DAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,0CAAA;AAjBJ;AAoBI;EACI,6DAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;AAlBR;AAoBQ;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;AAlBZ;AAqBQ;EACI,aAAA;EACA,eAAA;EACA,QAAA;EACA,eAAA;AAnBZ;AAqBY;EACI,6DAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,8CAAA;AAnBhB;AAqBgB;EACI,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sCAAA;AAnBpB;AAqBoB;EACI,0CAAA;AAnBxB;AA0BI;EACI,aAAA;EACA,uBAAA;EACA,WAAA;AAxBR;AA0BQ;EACI,kBAAA;EACA,gBAAA;EACA,WAAA;AAxBZ;AA0BY;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,cAAA;EACA,iBAAA;AAxBhB;AA2BY;EACI,WAAA;EACA,4BAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,+CAAA;AAzBhB;AA2BgB;EACI,aAAA;EACA,qBAAA;EACA,mFAAA;EACA,2BAAA;AAzBpB;AA4BgB;EACI,cAAA;EACA,kBAAA;AA1BpB;AAgCI;EACI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;AA9BR;AAgCQ;;EAEI,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;AA9BZ;AAgCY;;EACI,aAAA;EACA,qBAAA;EACA,8CAAA;EACA,2BAAA;AA7BhB;AAgCY;;EACI,qBAAA;EACA,2BAAA;AA7BhB;AAiCQ;EACI,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AA/BZ;AAiCY;EACI,2BAAA;EACA,6CAAA;AA/BhB;AAoCQ;EACI,aAAA;EACA,QAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;AAlCZ;AAoCY;EACI,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;AAlChB;AAoCgB;EACI,6DAAA;EACA,YAAA;EACA,8CAAA;AAlCpB;AAqCgB;EACI,oCAAA;EACA,cAAA;AAnCpB;AAyCQ;EACI,aAAA;EACA,SAAA;EACA,mBAAA;AAvCZ;AAyCY;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;AAvChB;AAyCgB;EACI,kBAAA;EACA,UAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;AAvCpB;AA0CgB;EACI,4BAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;AAxCpB;AA0CoB;EACI,aAAA;EACA,qBAAA;EACA,8CAAA;AAxCxB;AA2CoB;EACI,cAAA;EACA,iBAAA;AAzCxB;AAgDQ;EACI,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;AA9CZ;AAgDY;EACI,2BAAA;EACA,6CAAA;AA9ChB;AAiDY;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;EACA,6BAAA;AA/ChB;AAkDY;EACI,UAAA;AAhDhB;;AAuDA;EACI,6DAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,+CAAA;EACA,gDAAA;AApDJ;AAsDI;EACI,gBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sCAAA;AApDR;AAsDQ;EACI,0CAAA;AApDZ;;AA0DA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,6DAAA;EACA,mBAAA;EACA,0CAAA;AAvDJ;AAyDI;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,mDAAA;EACA,mBAAA;AAvDR;AA0DI;EACI,iBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;AAxDR;;AA8DI;EACI,6DAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,0CAAA;AA3DR;AA6DQ;EACI,eAAA;EACA,mBAAA;EACA,cAAA;AA3DZ;AA8DQ;EACI,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AA5DZ;AA+DQ;EACI,cAAA;EACA,SAAA;EACA,eAAA;AA7DZ;AAiEI;EACI,aAAA;EACA,4DAAA;EACA,SAAA;EACA,mBAAA;AA/DR;;AAoEA;EACI,6DAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;EACA,0CAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAjEJ;AAmEI;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,6DAAA;AAjER;AAoEI;EACI,2BAAA;EACA,2CAAA;AAlER;AAqEI;EACI,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;AAnER;AAqEQ;EACI,SAAA;AAnEZ;AAqEY;EACI,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AAnEhB;AAsEY;EACI,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AApEhB;AAwEQ;EACI,aAAA;EACA,QAAA;AAtEZ;AAwEY;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;AAtEhB;AAwEgB;EACI,6DAAA;EACA,YAAA;AAtEpB;AAwEoB;EACI,2BAAA;EACA,8CAAA;AAtExB;AA0EgB;EACI,6DAAA;EACA,YAAA;AAxEpB;AA0EoB;EACI,2BAAA;EACA,6CAAA;AAxExB;AA4EgB;EACI,6DAAA;EACA,YAAA;AA1EpB;AA4EoB;EACI,2BAAA;EACA,6CAAA;AA1ExB;AAiFI;EACI,mBAAA;AA/ER;AAiFQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,gCAAA;AA/EZ;AAiFY;EACI,mBAAA;AA/EhB;AAkFY;EACI,gBAAA;EACA,cAAA;EACA,kBAAA;AAhFhB;AAmFY;EACI,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;AAjFhB;AAsFI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;AApFR;AAsFQ;;EAEI,cAAA;EACA,gBAAA;AApFZ;;AA0FA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,6DAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;AAvFJ;AAyFI;EACI,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAvFR;AAyFQ;EACI,2BAAA;EACA,+CAAA;AAvFZ;AA0FQ;EACI,mBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;AAxFZ;AA4FI;EACI,aAAA;EACA,QAAA;AA1FR;AA4FQ;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AA1FZ;AA4FY;EACI,qBAAA;EACA,2BAAA;AA1FhB;AA6FY;EACI,6DAAA;EACA,YAAA;EACA,qBAAA;AA3FhB;;AAkGA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,2CAAA;AA/FJ;;AAmGA;EACI,6DAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,UAAA;EACA,0CAAA;EACA,8CAAA;EACA,gBAAA;AAhGJ;AAkGI;EACI,6DAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAhGR;AAkGQ;EACI,SAAA;EACA,iBAAA;EACA,gBAAA;AAhGZ;AAmGQ;EACI,gBAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sCAAA;AAjGZ;AAmGY;EACI,0CAAA;AAjGhB;AAsGI;EACI,aAAA;EACA,kBAAA;AApGR;AAsGQ;EACI,eAAA;EACA,mBAAA;EACA,cAAA;AApGZ;AAuGQ;EACI,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AArGZ;AAwGQ;EACI,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAtGZ;AAwGY;EACI,cAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AAtGhB;AAyGY;EACI,cAAA;EACA,iBAAA;AAvGhB;AA2GQ;EACI,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;AAzGZ;AA6GI;EACI,oBAAA;EACA,aAAA;EACA,SAAA;EACA,yBAAA;AA3GR;AA6GQ;EACI,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AA3GZ;AA6GY;EACI,mBAAA;EACA,2BAAA;AA3GhB;AA+GQ;EACI,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AA7GZ;AA+GY;EACI,2BAAA;EACA,6CAAA;AA7GhB;;AAoHA;EACI,6DAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,0CAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAjHJ;AAmHI;EACI,eAAA;EACA,gBAAA;EACA,6DAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,SAAA;AAjHR;AAoHI;EACI,6DAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAlHR;AAoHQ;EACI,2BAAA;EACA,+CAAA;AAlHZ;;AAwHA;EACI;IACI,UAAA;EArHN;EAuHE;IACI,UAAA;EArHN;AACF;AAwHA;EACI;IACI,UAAA;IACA,2BAAA;EAtHN;EAwHE;IACI,UAAA;IACA,wBAAA;EAtHN;AACF;AAyHA;EACI;IACI,UAAA;IACA,4BAAA;EAvHN;EAyHE;IACI,UAAA;IACA,wBAAA;EAvHN;AACF;AA0HA;EACI;IACI,uBAAA;EAxHN;EA0HE;IACI,yBAAA;EAxHN;AACF;AA4HA;EACI;IACI,aAAA;EA1HN;EA6HE;IACI,sBAAA;IACA,SAAA;IACA,kBAAA;EA3HN;EA6HM;IACI,eAAA;EA3HV;EA+HE;IACI,sBAAA;IACA,SAAA;EA7HN;EA+HM;IACI,eAAA;EA7HV;EAiIU;IACI,uBAAA;EA/Hd;EAiIc;IACI,iBAAA;IACA,gBAAA;EA/HlB;EAoIM;IACI,eAAA;IACA,uBAAA;IACA,sBAAA;IACA,SAAA;EAlIV;EAoIU;;IAEI,gBAAA;IACA,WAAA;EAlId;EAqIU;IACI,sBAAA;IACA,WAAA;EAnId;EAqIc;IACI,WAAA;EAnIlB;EAqIkB;IACI,WAAA;IACA,eAAA;EAnItB;EAwIU;IACI,WAAA;IACA,uBAAA;EAtId;EAyIU;;IAEI,WAAA;IACA,uBAAA;EAvId;EA4IE;IACI,0BAAA;IACA,SAAA;EA1IN;EA6IE;IACI,aAAA;EA3IN;EA6IM;IACI,sBAAA;IACA,SAAA;IACA,uBAAA;EA3IV;EA6IU;IACI,oBAAA;EA3Id;EA+IM;IACI,sBAAA;IACA,QAAA;IACA,kBAAA;EA7IV;EAiJE;IACI,sBAAA;IACA,SAAA;EA/IN;EAiJM;IACI,eAAA;IACA,uBAAA;EA/IV;EAmJE;IACI,UAAA;IACA,YAAA;EAjJN;EAmJM;IACI,sBAAA;IACA,SAAA;EAjJV;EAmJU;IACI,WAAA;EAjJd;AACF;AAsJA;EACI;IACI,iBAAA;EApJN;EAuJE;IACI,aAAA;EArJN;EAuJM;IACI,iBAAA;EArJV;EAwJM;IACI,WAAA;IACA,YAAA;IACA,eAAA;EAtJV;AACF","sourcesContent":["// Settings Component Styles\n.settingsContainer {\n    min-height: 100vh;\n    background: linear-gradient(135deg, #0467a0 0%, #035a8a 50%, #ff0000 100%);\n    padding: 20px;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n// Header Section\n.header {\n    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);\n    border-radius: 20px;\n    padding: 30px;\n    margin-bottom: 25px;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border: 2px solid rgba(255, 255, 255, 0.2);\n\n    .headerContent {\n        h1 {\n            font-size: 2.5rem;\n            font-weight: 700;\n            background: linear-gradient(135deg, #0467a0 0%, #ff0000 100%);\n            -webkit-background-clip: text;\n            -webkit-text-fill-color: transparent;\n            background-clip: text;\n            margin: 0 0 10px 0;\n            text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n        }\n\n        p {\n            font-size: 1.1rem;\n            color: #6c757d;\n            margin: 0;\n            font-weight: 500;\n        }\n    }\n\n    .headerActions {\n        display: flex;\n        gap: 15px;\n        align-items: center;\n\n        .downloadButton {\n            background: linear-gradient(135deg, #0467a0 0%, #035a8a 100%);\n            color: white;\n            border: none;\n            padding: 12px 24px;\n            border-radius: 12px;\n            font-size: 1rem;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.3s ease;\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            box-shadow: 0 4px 15px rgba(4, 103, 160, 0.3);\n\n            &:hover {\n                transform: translateY(-2px);\n                box-shadow: 0 6px 20px rgba(4, 103, 160, 0.4);\n            }\n\n            &:active {\n                transform: translateY(0);\n            }\n        }\n\n        .refreshButton {\n            background: linear-gradient(135deg, #0467a0 0%, #ff0000 100%);\n            color: white;\n            border: none;\n            padding: 12px 24px;\n            border-radius: 12px;\n            font-size: 1rem;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.3s ease;\n            display: flex;\n            align-items: center;\n            gap: 8px;\n            box-shadow: 0 4px 15px rgba(4, 103, 160, 0.3);\n\n            &:hover {\n                transform: translateY(-2px);\n                box-shadow: 0 6px 20px rgba(4, 103, 160, 0.4);\n            }\n\n            &:active {\n                transform: translateY(0);\n            }\n        }\n    }\n\n    // Responsive design for mobile devices\n    @media (max-width: 768px) {\n        flex-direction: column;\n        gap: 15px;\n\n        .headerContent {\n            text-align: center;\n            \n            h1 {\n                font-size: 2rem !important;\n            }\n        }\n\n        .headerActions {\n            flex-direction: column;\n            gap: 10px;\n            width: 100%;\n            \n            button {\n                width: 100%;\n                justify-content: center;\n            }\n        }\n    }\n}\n\n// Search and Filter Bar\n.searchFilterBar {\n    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);\n    border-radius: 15px;\n    padding: 25px;\n    margin-bottom: 25px;\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    border: 2px solid rgba(255, 255, 255, 0.2);\n\n    // Filter Summary\n    .filterSummary {\n        background: linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%);\n        border-radius: 10px;\n        padding: 15px;\n        border-left: 4px solid #667eea;\n\n        .filterSummaryLabel {\n            font-weight: 600;\n            color: #2c3e50;\n            margin-right: 10px;\n            font-size: 0.95rem;\n        }\n\n        .activeFilters {\n            display: flex;\n            flex-wrap: wrap;\n            gap: 8px;\n            margin-top: 8px;\n\n            .filterTag {\n                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n                color: white;\n                padding: 6px 12px;\n                border-radius: 20px;\n                font-size: 0.85rem;\n                font-weight: 500;\n                display: flex;\n                align-items: center;\n                gap: 6px;\n                box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);\n\n                button {\n                    background: none;\n                    border: none;\n                    color: white;\n                    font-size: 1rem;\n                    cursor: pointer;\n                    padding: 0;\n                    width: 16px;\n                    height: 16px;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    border-radius: 50%;\n                    transition: background-color 0.2s ease;\n\n                    &:hover {\n                        background-color: rgba(255, 255, 255, 0.2);\n                    }\n                }\n            }\n        }\n    }\n\n    .searchSection {\n        display: flex;\n        justify-content: center;\n        width: 100%;\n\n        .searchBox {\n            position: relative;\n            max-width: 500px;\n            width: 100%;\n\n            .searchIcon {\n                position: absolute;\n                left: 15px;\n                top: 50%;\n                transform: translateY(-50%);\n                color: #6c757d;\n                font-size: 1.1rem;\n            }\n\n            .searchInput {\n                width: 100%;\n                padding: 15px 15px 15px 50px;\n                border: 2px solid #e9ecef;\n                border-radius: 12px;\n                font-size: 1rem;\n                background: white;\n                transition: all 0.3s ease;\n                box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);\n\n                &:focus {\n                    outline: none;\n                    border-color: #667eea;\n                    box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1), inset 0 2px 4px rgba(0, 0, 0, 0.05);\n                    transform: translateY(-1px);\n                }\n\n                &::placeholder {\n                    color: #adb5bd;\n                    font-style: italic;\n                }\n            }\n        }\n    }\n\n    .filterSection {\n        display: flex;\n        gap: 15px;\n        align-items: center;\n        flex-wrap: wrap;\n        justify-content: center;\n\n        .filterSelect,\n        .sortSelect {\n            padding: 12px 16px;\n            border: 2px solid #e9ecef;\n            border-radius: 10px;\n            font-size: 0.95rem;\n            background: white;\n            cursor: pointer;\n            transition: all 0.3s ease;\n            min-width: 150px;\n            font-weight: 500;\n\n            &:focus {\n                outline: none;\n                border-color: #667eea;\n                box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n                transform: translateY(-1px);\n            }\n\n            &:hover {\n                border-color: #667eea;\n                transform: translateY(-1px);\n            }\n        }\n\n        .sortButton {\n            background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n            color: white;\n            border: none;\n            padding: 12px 16px;\n            border-radius: 10px;\n            font-size: 0.95rem;\n            cursor: pointer;\n            transition: all 0.3s ease;\n            display: flex;\n            align-items: center;\n            gap: 6px;\n            font-weight: 600;\n\n            &:hover {\n                transform: translateY(-2px);\n                box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);\n            }\n        }\n\n        // Date Filter Toggle\n        .dateFilterToggle {\n            display: flex;\n            gap: 5px;\n            background: #f8f9fa;\n            border-radius: 8px;\n            padding: 4px;\n            border: 1px solid #e9ecef;\n\n            .dateTypeButton {\n                background: none;\n                border: none;\n                padding: 8px 12px;\n                border-radius: 6px;\n                font-size: 0.85rem;\n                cursor: pointer;\n                transition: all 0.3s ease;\n                color: #6c757d;\n                font-weight: 500;\n\n                &.active {\n                    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n                    color: white;\n                    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);\n                }\n\n                &:hover:not(.active) {\n                    background: rgba(102, 126, 234, 0.1);\n                    color: #667eea;\n                }\n            }\n        }\n\n        // Date Range Section\n        .dateRangeSection {\n            display: flex;\n            gap: 10px;\n            align-items: center;\n\n            .dateInput {\n                position: relative;\n                display: flex;\n                align-items: center;\n\n                .dateIcon {\n                    position: absolute;\n                    left: 12px;\n                    color: #6c757d;\n                    font-size: 0.9rem;\n                    z-index: 1;\n                }\n\n                .dateInputField {\n                    padding: 10px 10px 10px 35px;\n                    border: 2px solid #e9ecef;\n                    border-radius: 8px;\n                    font-size: 0.9rem;\n                    background: white;\n                    transition: all 0.3s ease;\n                    min-width: 140px;\n\n                    &:focus {\n                        outline: none;\n                        border-color: #667eea;\n                        box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n                    }\n\n                    &::placeholder {\n                        color: #adb5bd;\n                        font-size: 0.8rem;\n                    }\n                }\n            }\n        }\n\n        // Clear Filters Button\n        .clearFiltersButton {\n            background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);\n            color: white;\n            border: none;\n            padding: 12px 16px;\n            border-radius: 10px;\n            font-size: 0.9rem;\n            cursor: pointer;\n            transition: all 0.3s ease;\n            display: flex;\n            align-items: center;\n            gap: 6px;\n            font-weight: 600;\n            position: relative;\n\n            &:hover {\n                transform: translateY(-2px);\n                box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);\n            }\n\n            &::before {\n                content: '';\n                position: absolute;\n                top: -2px;\n                right: -2px;\n                width: 8px;\n                height: 8px;\n                background: #ffc107;\n                border-radius: 50%;\n                opacity: 0;\n                transition: opacity 0.3s ease;\n            }\n\n            &.hasFilters::before {\n                opacity: 1;\n            }\n        }\n    }\n}\n\n// Error Message\n.errorMessage {\n    background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);\n    color: white;\n    padding: 15px 20px;\n    border-radius: 12px;\n    margin-bottom: 20px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    box-shadow: 0 4px 15px rgba(255, 107, 107, 0.3);\n    animation: slideInDown 0.3s ease;\n\n    button {\n        background: none;\n        border: none;\n        color: white;\n        font-size: 1.2rem;\n        cursor: pointer;\n        padding: 0;\n        width: 24px;\n        height: 24px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 50%;\n        transition: background-color 0.2s ease;\n\n        &:hover {\n            background-color: rgba(255, 255, 255, 0.2);\n        }\n    }\n}\n\n// Loading Container\n.loadingContainer {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 60px 20px;\n    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);\n    border-radius: 20px;\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);\n\n    .loadingSpinner {\n        width: 50px;\n        height: 50px;\n        border: 4px solid #e9ecef;\n        border-top: 4px solid #667eea;\n        border-radius: 50%;\n        animation: spin 1s linear infinite;\n        margin-bottom: 20px;\n    }\n\n    p {\n        font-size: 1.1rem;\n        color: #6c757d;\n        margin: 0;\n        font-weight: 500;\n    }\n}\n\n// Items Container\n.itemsContainer {\n    .emptyState {\n        background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);\n        border-radius: 20px;\n        padding: 60px 20px;\n        text-align: center;\n        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);\n\n        .emptyIcon {\n            font-size: 4rem;\n            margin-bottom: 20px;\n            display: block;\n        }\n\n        h3 {\n            font-size: 1.5rem;\n            color: #495057;\n            margin: 0 0 10px 0;\n            font-weight: 600;\n        }\n\n        p {\n            color: #6c757d;\n            margin: 0;\n            font-size: 1rem;\n        }\n    }\n\n    .itemsGrid {\n        display: grid;\n        grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));\n        gap: 25px;\n        margin-bottom: 30px;\n    }\n}\n\n// Item Card\n.itemCard {\n    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);\n    border-radius: 18px;\n    padding: 25px;\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);\n    border: 2px solid rgba(255, 255, 255, 0.2);\n    transition: all 0.3s ease;\n    position: relative;\n    overflow: hidden;\n\n    &::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        height: 4px;\n        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    }\n\n    &:hover {\n        transform: translateY(-5px);\n        box-shadow: 0 15px 35px rgba(0, 0, 0, 0.15);\n    }\n\n    .itemHeader {\n        display: flex;\n        justify-content: space-between;\n        align-items: flex-start;\n        margin-bottom: 20px;\n\n        .itemTitle {\n            flex: 1;\n\n            h3 {\n                font-size: 1.3rem;\n                font-weight: 700;\n                color: #2c3e50;\n                margin: 0 0 8px 0;\n                line-height: 1.3;\n            }\n\n            .itemId {\n                font-size: 0.9rem;\n                color: #6c757d;\n                font-weight: 500;\n                background: #e9ecef;\n                padding: 4px 8px;\n                border-radius: 6px;\n                display: inline-block;\n            }\n        }\n\n        .itemActions {\n            display: flex;\n            gap: 8px;\n\n            .actionButton {\n                width: 40px;\n                height: 40px;\n                border: none;\n                border-radius: 10px;\n                cursor: pointer;\n                transition: all 0.3s ease;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                font-size: 1.1rem;\n                font-weight: 600;\n\n                &.viewButton {\n                    background: linear-gradient(135deg, #17a2b8 0%, #20c997 100%);\n                    color: white;\n\n                    &:hover {\n                        transform: translateY(-2px);\n                        box-shadow: 0 4px 15px rgba(23, 162, 184, 0.3);\n                    }\n                }\n\n                &.editButton {\n                    background: linear-gradient(135deg, #ffc107 0%, #fd7e14 100%);\n                    color: white;\n\n                    &:hover {\n                        transform: translateY(-2px);\n                        box-shadow: 0 4px 15px rgba(255, 193, 7, 0.3);\n                    }\n                }\n\n                &.deleteButton {\n                    background: linear-gradient(135deg, #dc3545 0%, #e74c3c 100%);\n                    color: white;\n\n                    &:hover {\n                        transform: translateY(-2px);\n                        box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);\n                    }\n                }\n            }\n        }\n    }\n\n    .itemDetails {\n        margin-bottom: 20px;\n\n        .detailRow {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            padding: 8px 0;\n            border-bottom: 1px solid #f1f3f4;\n\n            &:last-child {\n                border-bottom: none;\n            }\n\n            .detailLabel {\n                font-weight: 600;\n                color: #495057;\n                font-size: 0.95rem;\n            }\n\n            .detailValue {\n                color: #6c757d;\n                font-weight: 500;\n                font-size: 0.95rem;\n                text-align: right;\n                max-width: 60%;\n                word-break: break-word;\n            }\n        }\n    }\n\n    .itemFooter {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding-top: 15px;\n        border-top: 1px solid #f1f3f4;\n        font-size: 0.85rem;\n\n        .createdDate,\n        .updatedDate {\n            color: #6c757d;\n            font-weight: 500;\n        }\n    }\n}\n\n// Pagination\n.pagination {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 15px;\n    margin-top: 30px;\n    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);\n    border-radius: 15px;\n    padding: 20px;\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);\n\n    .paginationButton {\n        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n        color: white;\n        border: none;\n        padding: 12px 20px;\n        border-radius: 10px;\n        font-size: 0.95rem;\n        font-weight: 600;\n        cursor: pointer;\n        transition: all 0.3s ease;\n\n        &:hover:not(:disabled) {\n            transform: translateY(-2px);\n            box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);\n        }\n\n        &:disabled {\n            background: #e9ecef;\n            color: #6c757d;\n            cursor: not-allowed;\n            transform: none;\n        }\n    }\n\n    .pageNumbers {\n        display: flex;\n        gap: 8px;\n\n        .pageButton {\n            width: 40px;\n            height: 40px;\n            border: 2px solid #e9ecef;\n            background: white;\n            border-radius: 8px;\n            font-size: 0.95rem;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.3s ease;\n\n            &:hover {\n                border-color: #667eea;\n                transform: translateY(-1px);\n            }\n\n            &.activePage {\n                background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n                color: white;\n                border-color: #667eea;\n            }\n        }\n    }\n}\n\n// Modal Overlay\n.modalOverlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.6);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    animation: fadeIn 0.3s ease;\n}\n\n// Confirmation Modal\n.confirmationModal {\n    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);\n    border-radius: 20px;\n    padding: 0;\n    max-width: 500px;\n    width: 90%;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n    animation: slideInUp 0.3s ease;\n    overflow: hidden;\n\n    .modalHeader {\n        background: linear-gradient(135deg, #dc3545 0%, #e74c3c 100%);\n        color: white;\n        padding: 25px 30px;\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n\n        h3 {\n            margin: 0;\n            font-size: 1.4rem;\n            font-weight: 700;\n        }\n\n        .closeButton {\n            background: none;\n            border: none;\n            color: white;\n            font-size: 1.5rem;\n            cursor: pointer;\n            padding: 0;\n            width: 30px;\n            height: 30px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            border-radius: 50%;\n            transition: background-color 0.2s ease;\n\n            &:hover {\n                background-color: rgba(255, 255, 255, 0.2);\n            }\n        }\n    }\n\n    .modalContent {\n        padding: 30px;\n        text-align: center;\n\n        .warningIcon {\n            font-size: 3rem;\n            margin-bottom: 20px;\n            display: block;\n        }\n\n        p {\n            font-size: 1.1rem;\n            color: #495057;\n            margin: 0 0 20px 0;\n            font-weight: 500;\n        }\n\n        .itemPreview {\n            background: #f8f9fa;\n            border-radius: 10px;\n            padding: 15px;\n            margin-bottom: 20px;\n            border-left: 4px solid #dc3545;\n\n            strong {\n                display: block;\n                color: #2c3e50;\n                font-size: 1.1rem;\n                margin-bottom: 5px;\n            }\n\n            span {\n                color: #6c757d;\n                font-size: 0.9rem;\n            }\n        }\n\n        .warningText {\n            color: #dc3545;\n            font-size: 0.95rem;\n            font-weight: 600;\n            background: #fff5f5;\n            padding: 15px;\n            border-radius: 8px;\n            border: 1px solid #fed7d7;\n        }\n    }\n\n    .modalActions {\n        padding: 0 30px 30px;\n        display: flex;\n        gap: 15px;\n        justify-content: flex-end;\n\n        .cancelButton {\n            background: #6c757d;\n            color: white;\n            border: none;\n            padding: 12px 24px;\n            border-radius: 10px;\n            font-size: 1rem;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.3s ease;\n\n            &:hover {\n                background: #5a6268;\n                transform: translateY(-1px);\n            }\n        }\n\n        .deleteConfirmButton {\n            background: linear-gradient(135deg, #dc3545 0%, #e74c3c 100%);\n            color: white;\n            border: none;\n            padding: 12px 24px;\n            border-radius: 10px;\n            font-size: 1rem;\n            font-weight: 600;\n            cursor: pointer;\n            transition: all 0.3s ease;\n\n            &:hover {\n                transform: translateY(-1px);\n                box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);\n            }\n        }\n    }\n}\n\n// Edit Form Header\n.editFormHeader {\n    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);\n    border-radius: 20px;\n    padding: 25px 30px;\n    margin-bottom: 25px;\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    h2 {\n        font-size: 2rem;\n        font-weight: 700;\n        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n        -webkit-background-clip: text;\n        -webkit-text-fill-color: transparent;\n        background-clip: text;\n        margin: 0;\n    }\n\n    .backButton {\n        background: linear-gradient(135deg, #6c757d 0%, #495057 100%);\n        color: white;\n        border: none;\n        padding: 12px 24px;\n        border-radius: 12px;\n        font-size: 1rem;\n        font-weight: 600;\n        cursor: pointer;\n        transition: all 0.3s ease;\n        display: flex;\n        align-items: center;\n        gap: 8px;\n\n        &:hover {\n            transform: translateY(-2px);\n            box-shadow: 0 4px 15px rgba(108, 117, 125, 0.3);\n        }\n    }\n}\n\n// Animations\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n@keyframes slideInUp {\n    from {\n        opacity: 0;\n        transform: translateY(30px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes slideInDown {\n    from {\n        opacity: 0;\n        transform: translateY(-30px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n// Responsive Design\n@media (max-width: 768px) {\n    .settingsContainer {\n        padding: 15px;\n    }\n\n    .header {\n        flex-direction: column;\n        gap: 20px;\n        text-align: center;\n\n        .headerContent h1 {\n            font-size: 2rem;\n        }\n    }\n\n    .searchFilterBar {\n        flex-direction: column;\n        gap: 15px;\n\n        .searchSection .searchBox {\n            max-width: 100%;\n        }\n\n        .filterSummary {\n            .activeFilters {\n                justify-content: center;\n                \n                .filterTag {\n                    font-size: 0.8rem;\n                    padding: 4px 8px;\n                }\n            }\n        }\n\n        .filterSection {\n            flex-wrap: wrap;\n            justify-content: center;\n            flex-direction: column;\n            gap: 10px;\n\n            .filterSelect,\n            .sortSelect {\n                min-width: 120px;\n                width: 100%;\n            }\n\n            .dateRangeSection {\n                flex-direction: column;\n                width: 100%;\n\n                .dateInput {\n                    width: 100%;\n\n                    .dateInputField {\n                        width: 100%;\n                        min-width: auto;\n                    }\n                }\n            }\n\n            .dateFilterToggle {\n                width: 100%;\n                justify-content: center;\n            }\n\n            .clearFiltersButton,\n            .sortButton {\n                width: 100%;\n                justify-content: center;\n            }\n        }\n    }\n\n    .itemsGrid {\n        grid-template-columns: 1fr;\n        gap: 20px;\n    }\n\n    .itemCard {\n        padding: 20px;\n\n        .itemHeader {\n            flex-direction: column;\n            gap: 15px;\n            align-items: flex-start;\n\n            .itemActions {\n                align-self: flex-end;\n            }\n        }\n\n        .itemFooter {\n            flex-direction: column;\n            gap: 8px;\n            text-align: center;\n        }\n    }\n\n    .pagination {\n        flex-direction: column;\n        gap: 15px;\n\n        .pageNumbers {\n            flex-wrap: wrap;\n            justify-content: center;\n        }\n    }\n\n    .confirmationModal {\n        width: 95%;\n        margin: 20px;\n\n        .modalActions {\n            flex-direction: column;\n            gap: 10px;\n\n            button {\n                width: 100%;\n            }\n        }\n    }\n}\n\n@media (max-width: 480px) {\n    .header .headerContent h1 {\n        font-size: 1.8rem;\n    }\n\n    .itemCard {\n        padding: 15px;\n\n        .itemHeader .itemTitle h3 {\n            font-size: 1.1rem;\n        }\n\n        .itemActions .actionButton {\n            width: 35px;\n            height: 35px;\n            font-size: 1rem;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"settingsContainer": `Settings_settingsContainer__f6vbr`,
	"header": `Settings_header__Mx7Zp`,
	"headerContent": `Settings_headerContent__N6Zab`,
	"headerActions": `Settings_headerActions__JMlFK`,
	"downloadButton": `Settings_downloadButton__RzieJ`,
	"refreshButton": `Settings_refreshButton__Bazue`,
	"searchFilterBar": `Settings_searchFilterBar__SBmUI`,
	"filterSummary": `Settings_filterSummary__Lf4iE`,
	"filterSummaryLabel": `Settings_filterSummaryLabel__-qwXJ`,
	"activeFilters": `Settings_activeFilters__YasHQ`,
	"filterTag": `Settings_filterTag__h4y+6`,
	"searchSection": `Settings_searchSection__u1-MJ`,
	"searchBox": `Settings_searchBox__ekRwS`,
	"searchIcon": `Settings_searchIcon__2NzQU`,
	"searchInput": `Settings_searchInput__UeYSY`,
	"filterSection": `Settings_filterSection__R2uVg`,
	"filterSelect": `Settings_filterSelect__NVxK8`,
	"sortSelect": `Settings_sortSelect__cEJFv`,
	"sortButton": `Settings_sortButton__Trzou`,
	"dateFilterToggle": `Settings_dateFilterToggle__0YHtb`,
	"dateTypeButton": `Settings_dateTypeButton__sDl67`,
	"active": `Settings_active__Oddne`,
	"dateRangeSection": `Settings_dateRangeSection__rDaP+`,
	"dateInput": `Settings_dateInput__6zaor`,
	"dateIcon": `Settings_dateIcon__lyALk`,
	"dateInputField": `Settings_dateInputField__B9Bje`,
	"clearFiltersButton": `Settings_clearFiltersButton__m6652`,
	"hasFilters": `Settings_hasFilters__4tJuv`,
	"errorMessage": `Settings_errorMessage__bFpI5`,
	"slideInDown": `Settings_slideInDown__L4FPL`,
	"loadingContainer": `Settings_loadingContainer__iG9YI`,
	"loadingSpinner": `Settings_loadingSpinner__UmfJH`,
	"spin": `Settings_spin__2fjp+`,
	"itemsContainer": `Settings_itemsContainer__96kQX`,
	"emptyState": `Settings_emptyState__NEseT`,
	"emptyIcon": `Settings_emptyIcon__S+yLM`,
	"itemsGrid": `Settings_itemsGrid__mS7F+`,
	"itemCard": `Settings_itemCard__Powmv`,
	"itemHeader": `Settings_itemHeader__SCwd5`,
	"itemTitle": `Settings_itemTitle__nGE68`,
	"itemId": `Settings_itemId__ZQrc7`,
	"itemActions": `Settings_itemActions__+cVS7`,
	"actionButton": `Settings_actionButton__H6fY2`,
	"viewButton": `Settings_viewButton__VwDo1`,
	"editButton": `Settings_editButton__LL-RN`,
	"deleteButton": `Settings_deleteButton__srDaK`,
	"itemDetails": `Settings_itemDetails__AIdBH`,
	"detailRow": `Settings_detailRow__nLiiN`,
	"detailLabel": `Settings_detailLabel__e0M-y`,
	"detailValue": `Settings_detailValue__7vVQm`,
	"itemFooter": `Settings_itemFooter__sgGZT`,
	"createdDate": `Settings_createdDate__IhkG-`,
	"updatedDate": `Settings_updatedDate__UEqid`,
	"pagination": `Settings_pagination__sbN-9`,
	"paginationButton": `Settings_paginationButton__JEvQG`,
	"pageNumbers": `Settings_pageNumbers__7Ldrb`,
	"pageButton": `Settings_pageButton__ADCGa`,
	"activePage": `Settings_activePage__GkJVT`,
	"modalOverlay": `Settings_modalOverlay__9ASjN`,
	"fadeIn": `Settings_fadeIn__7gJaS`,
	"confirmationModal": `Settings_confirmationModal__FP-R+`,
	"slideInUp": `Settings_slideInUp__OerG1`,
	"modalHeader": `Settings_modalHeader__NuRGy`,
	"closeButton": `Settings_closeButton__dsii1`,
	"modalContent": `Settings_modalContent__hkX0k`,
	"warningIcon": `Settings_warningIcon__9hxU7`,
	"itemPreview": `Settings_itemPreview__-uWE5`,
	"warningText": `Settings_warningText__QzYNK`,
	"modalActions": `Settings_modalActions__ICG7s`,
	"cancelButton": `Settings_cancelButton__6EHQT`,
	"deleteConfirmButton": `Settings_deleteConfirmButton__+821q`,
	"editFormHeader": `Settings_editFormHeader__8Jpco`,
	"backButton": `Settings_backButton__BURpw`
};
export default ___CSS_LOADER_EXPORT___;
